import { atom } from "recoil";

// ナビのバッジに使う、AIオファーの確認待ちバッチ数。
export const AiOfferPendingCount = atom<{ pending_count: number }>({
  key: "AiOfferPendingCount",
  default: {
    pending_count: 0,
  },
});
